<script setup>
  import { ref, onBeforeMount } from "vue";
  import { useUiStore } from "@/stores/ui";
  import { useUsersStore } from "@/stores/users";
import { useCompanyStore } from "@/stores/company";

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const usersStore = useUsersStore();
  const companyId = useCompanyStore().companyId;

  let id = ref(null);
  let userName = ref(null);
  let isSubmitted = ref(false);

  const onSubmit = () => {
    isSubmitted.value = true;
    usersStore.deleteUser({id : id.value, companyId })
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () => {
    uiStore.resetModalStore();
  };

  onBeforeMount(() => {
    if(uiStore.modalData && uiStore.modalData.first_name && uiStore.modalAction == 'delete_user'){
      id.value = uiStore.modalData.id;
      userName.value = `${uiStore.modalData.first_name} ${uiStore.modalData.last_name}`;
    }
  });
</script>
<template>
  <DModal :visible="uiStore.modalAction === 'delete_user'" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete User </template>
    <template #body>
      <div class="delete-text">
        <span>Are you sure you want to <b>"Delete"</b> the user <b>{{ userName }}</b> ?</span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-danger add-button mr-30" >
            Delete <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
